import React from "react";

const FTFCDocs = (
    <html>
    <p>
        This is a setup that tracks full time frame continuity. This setup will
        trigger entry tactics once all of the time frames you provide us are above
        the open if long, or below the open if short.
    </p>
    <p>
        You choose these setups by manipulating the list that shows when you click
        the FTFC setup. "m" is for minute, "d" is for day, "w is for week, "M" is
        for month. The parameter candle represents the candle duration of the time
        frame. If you wanted to trade the 60 minute candle (starting from 9:30), you
        would type in 60 for the candle parameter, and click "m" as the timeUnit.
    </p>
    <p>
        The red X button on the right will remove the associated timeFrame. The
        green plus beneath with add another timeFrame.
    </p>
    EX:
    <p>
        Let's say I want to trade AAPL, either long or short, when the 1 hour, the 1
        day, the 1 week, and the 1 month, all are the same color. I would enter as
        the setup: 60m, 1d, 1w, and 1m. If at any point, all of those time frames
        are above their respective open (the UI will show green), the setup will
        trigger long. If, at anytime, all of those time frames are below their
        respective open, it will trigger short.
    </p>
    <p>NOTE:</p>
    <p>
        We calculate hours by market open, 9:30 am. If you use another platform and have pre market on,
        you might end up having a different candle open time than us. For example, if you trade the hour charts and
        have premarket on on TOS, the hourly candle starts at 9:00 am, since they are calculating since 4 am. As of
        now, we are always starting from 9:30 am.
    </p>
    </html>
);
export default FTFCDocs;
